import React, { useEffect, useState } from "react";
import { get } from "../../utility/fetch";
import SubmitFeedback from "../layouts/SubmitFeedback";


function Dashboard() {
  const userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
   function getRoleTitle(roles) {
  if (!Array.isArray(roles) || roles.length === 0) return "No Role";

  let roleString = "";

  const hasRole = (roleName) => roles.includes(roleName);

  // Priority 1: Super Admin or more than 7 roles
  if (hasRole("Super Admin") || roles.length > 7) {
    roleString = "Super Admin";
  }
  // Priority 2: Only one role
  else if (roles.length === 1) {
    roleString = roles[0];
  }
  // Priority 3: Nurse and checkin
  else if (hasRole("Nurse") && hasRole("checkin")) {
    roleString = "Checkin Nurse";
  }
  // Priority 4: Nurse and Local Admin
  else if (hasRole("Nurse") && hasRole("Local Admin")) {
    roleString = "Admin Nurse";
  }
  // Fallback
  else {
    roleString = roles[0]; // default to first role
  }

  // Add "- Admin Manager" if Health Finance Admin is present
  if (hasRole("Health Finance Admin")) {
    roleString += " - Admin Manager";
  }

  return roleString;
}
  return (
    <div style={{ position: "relative", minHeight: "70vh" }}>

      <div className="w-100 m-t-60" style={{ position: "relative", zIndex: 1 }}>
        <div className="m-t-40">
          <span>Good Day</span>
          <h3>{userInfo?.firstName} {userInfo?.lastName}</h3>
                <p className="role">{getRoleTitle(userInfo?.role)}</p>

                {/* <SubmitFeedback/> */}
          {/* <span>{userInfo?.role}</span> */}
        </div>

      
      </div>
    </div>

  );
}

export default Dashboard;
